function custom_select(){
  $('.custom-select').each(function(){
      var $this = $(this);
      var numberOfOptions = $(this).children('option').length;
	  var selectedOption = $(this).children('option:selected').val();
	  var selectedText = $(this).children('option:selected').text();
    
      $this.addClass('select-hidden'); 
      $this.wrap('<div class="custom-select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');
      $styledSelect.text($this.children('option:selected').text());

      var $list = $('<ul />', {
          'class': 'select-options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
              text: $this.children('option').eq(i).text(),
              rel: $this.children('option').eq(i).val()
          }).appendTo($list);
          //if ($this.children('option').eq(i).is(':selected')){
          //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
          //}
      }

      var $listItems = $list.children('li');

      $styledSelect.click(function(e) {
          e.stopPropagation();
          $('div.select-styled.active').not(this).each(function(){
              $(this).removeClass('active').next('ul.select-options').hide();
          });
          $(this).toggleClass('active').next('ul.select-options').toggle();
      });

      $listItems.click(function(e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.hide();
          // console.log($this.val());
          FilterApi.setParam('sort', $(this).attr('rel'));
          FilterApi.setParam('page', 1);
          FilterApi.applyFilter('sort');
          setTimeout(function(){
            custom_select();
          }, 2000);

      });

      $(document).click(function() {
          $styledSelect.removeClass('active');
          $list.hide();
      });

  });
}
